export const DEFAULT_TASK_TRACKER_BOARD_CARDS_LIMIT = 7

export const MAX_TASK_TRACKER_BOARD_CARDS_LIMIT = 500

export const DEFAULT_TASK_TRACKER_COLUMN_ITEMS_LIMIT = 20

export const MAX_TASK_TRACKER_COLUMN_ITEMS_LIMIT = 100
